import DELETE_ACTIONS from 'src/MultiDeletionFunctionality/@state_manager/actions';
import DeletionContext from 'src/MultiDeletionFunctionality/@state/DeletionStateContext';
import {
  NoInformationFound,
  Pagination,
  PowerTable,
  ConfirmDelete,
} from 'Components';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import SuppliesDesktopHeader from './SuppliesDesktopHeader/SuppliesDesktopHeader';
import SuppliesDesktopSearchHeader from './SuppliesDesktopSearchHeader/SuppliesDesktopSearchHeader';

const SuppliesDesktop = ({
  isGlobalSearch,
  data,
  tabs,
  pageSizes,
  handlePageSizeChange,
  handlePageNumberChange,
  handleTabClick,
  setAppState,
  setPageState,
  onSearchDownload,
  onPinClick,
  powerTableIndex,
  menuOptions,
  rowRules,
  onOptionClick,
  ordersSearchKeyPairs,
  isSupplyWarningON,
  isTemplateWarningON,
  isSubmissionWarningON,
  multiDeletionSubmissionHandler,
  isPrepaid
}) => {
  const { deletionState, dispatch } = useContext(DeletionContext);

  const showNoInformationFound = !data.isLoading && data.data.length === 0;
  const suppliesSearchKeyPairs = {
    keys: isGlobalSearch ? ordersSearchKeyPairs.keys : data.keys,
    keyPairs: isGlobalSearch ? ordersSearchKeyPairs.keyPairs : data.keyPairs,
    viewCode: isGlobalSearch ? ordersSearchKeyPairs.viewCode : data.viewCode,
  };

  return (
    <div className="supplies">
      {isGlobalSearch ? (
        <SuppliesDesktopSearchHeader onSearchDownload={onSearchDownload} />
      ) : (
        <SuppliesDesktopHeader
            tabs={tabs}
            tabIndex={data.tabIndex}
            pageSize={pageSizes}
            onTabsClick={handleTabClick}
            onPageSizeChange={handlePageSizeChange}
            showNoInformationFound={showNoInformationFound}
            isSupplyWarningON={isSupplyWarningON}
            isPrepaid={isPrepaid}
            setAppState={setAppState}
        />
      )}
      {showNoInformationFound && !isGlobalSearch ? (
        <NoInformationFound
          titleText={i18n.t('orders:NoOrders')}
          subText={i18n.t('orders:NewOrder1')}
          linkText={i18n.t('orders:NewOrder2')}
          link="/supplies/new"
        />
      ) : (
        !showNoInformationFound && (
          <PowerTable
            {...data}
            {...suppliesSearchKeyPairs}
            setAppState={setAppState}
            setPageState={setPageState}
            onPinClick={onPinClick}
            powerTableIndex={powerTableIndex}
            menuOptions={menuOptions}
            rowRules={rowRules}
            onOptionClick={onOptionClick}
            moreVertHelperText={i18n.t('tutorials:supplies.moreVert')}
            isSupplyWarningON={isSupplyWarningON}
            isTemplateWarningON={isTemplateWarningON}
            isSubmissionWarningON={isSubmissionWarningON}
            isPrepaid={isPrepaid}
          />
        )
      )}
      {isGlobalSearch && showNoInformationFound && (
        <NoInformationFound
          titleText={i18n.t('orders:NoResults')}
          subText={i18n.t('orders:NoResultsBody')}
        />
      )}
      <div className="supplies__pagination">
        <Pagination
          onClick={handlePageNumberChange}
          currentPage={data.pageNumber}
          itemsPerPage={data.pageSize}
          totalItems={data.totalItems}
        />
      </div>

      {/* //! Replace with confirmation message component */}
      {deletionState.isDeleteConfirmationActive && (
        <ConfirmDelete
          title={i18n.t('multiDeletion:MultiDeleteRecordsConfirmation')}
          onCancelDelete={() => {
            dispatch({ type: DELETE_ACTIONS.DEACTIVATE_DELETE_CONFIRMATION });
          }}
          onProceedDelete={() => {
            multiDeletionSubmissionHandler();
            dispatch({ type: DELETE_ACTIONS.DEACTIVATE_DELETE_CONFIRMATION });
          }}
        />
      )}
    </div>
  );
};

SuppliesDesktop.propTypes = {
  ordersSearchKeyPairs: PropTypes.shape({}),
  setAppState: PropTypes.func,
  onRowClick: PropTypes.func,
  onMoreOptionsClick: PropTypes.func,
  onPageChange: PropTypes.func,
  onTabsChange: PropTypes.func,
  isGlobalSearch: PropTypes.bool,
  powerTableIndex: PropTypes.number,
  tabs: PropTypes.arrayOf(PropTypes.string),
  tabIndex: PropTypes.number,
  data: PropTypes.shape({
    isLoading: PropTypes.bool,
    data: PropTypes.shape([]),
    keys: PropTypes.shape([]),
    keyPairs: PropTypes.shape({}),
  }),
  pageSizes: PropTypes.arrayOf(PropTypes.number),
  handlePageSizeChange: PropTypes.func,
  onOptionClick: PropTypes.func,
  handlePageNumberChange: PropTypes.func,
  handleTabClick: PropTypes.func,
  onSearchDownload: PropTypes.func,
  setPageState: PropTypes.func,
  onPinClick: PropTypes.func,
  menuOptions: PropTypes.arrayOf(PropTypes.shape({})),
  rowRules: PropTypes.func,
  isSupplyWarningON: PropTypes.bool,
  isTemplateWarningON: PropTypes.bool,
  isSubmissionWarningON: PropTypes.bool,
  multiDeletionSubmissionHandler: PropTypes.func,
  isPrepaid: PropTypes.bool,
};

export default SuppliesDesktop;



// WEBPACK FOOTER //
// ./src/containers/Supplies/SuppliesDesktop/SuppliesDesktop.jsx